import React from 'react';
import { useIntl } from 'react-intl';
import { Container } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';
import { SmartlinksFloatingFeatures } from './SmartlinksFloatingFeatures';

export const FeaturesOverall: React.FC = () => {
  const intl = useIntl();
  return (
    <div style={{ position: 'relative' }} className="smartlinks-subpages-description">
      <Container>
        <h2 className="main-header pt-5 pb-3 text-white text-center">
          {intl.formatMessage({
            id: 'sml.web.smartlinks.features.description.title',
            defaultMessage: 'Easy-to-use platform'
          })}
        </h2>
        <p className="header-subtitle pb-4 text-center">
          {intl.formatMessage({
            id: 'sml.web.smartlinks.features.description.subtitle',
            defaultMessage: 'Use different widgets to build your Smart Link page.'
          })}
        </p>
      </Container>
      <div className="bg-subpages-waves">
        <img src={nextAsset('images/smartLinks/wave-subpages.svg')} alt="Background Waves" />
      </div>
      <SmartlinksFloatingFeatures />
    </div>
  );
};
